export function toLocalISOString(date: Date, withMS: boolean = false) {
  const tzOffset = date.getTimezoneOffset() * 60_000; // offset in milliseconds
  const fixDate = date.getTime() - tzOffset;
  const isoString = new Date(fixDate).toISOString();
  return withMS ? isoString.slice(0, -1) : isoString.split('.')[0];
}

/**
 * Convert a time in "HH:MM" format to minutes.
 * This allows time comparisons by converting times into a numerical value.
 *
 * @param {string} time - The time in "HH:MM" format.
 * @returns {number} The number of minutes.
 */
export function timeStringToMinutes(time: string): number {
  const [hours, minutes] = time.split(':').map(Number);
  return hours * 60 + minutes;
}
